const extractHeader = (data, t) => {
  // static part of header
  const header = [
    t('position.Event'),
    t('position.Series'),
    t('position.Company'),
    t('position.VoucherText'),
    `${t('position.Debit')}/${t('position.Credit')}`,
    t('position.Account'),
    t('position.TransactionText'),
  ];
  if (data.accountingObjects.length > 0) {
    // dynamic part of header
    const names = data.accountingObjects.map(x => x.name);
    // insert accounting objects at penultimate location
    header.splice(header.length - 1, 0, ...names);
  }
  return header;
};

let lengthOfAccountingObjects = 0;

const extractAccountingObjectValues = accountingObjects => {
  if (lengthOfAccountingObjects > 0) {
    const valuesOfAccountingObjects = [];
    accountingObjects.forEach(accountingObject => {
      valuesOfAccountingObjects.push(accountingObject.value);
    });
    return valuesOfAccountingObjects;
  }
  return [];
};

const extractRows = (data, t) => {
  if (data.accountingObjects.length > 0) {
    lengthOfAccountingObjects = data.accountingObjects.length;
  }
  const rows = [];
  data.vouchers.forEach(voucher => {
    const row1 = [];
    const row2 = [];
    // first row has real values
    row1.push(t(`eventType.${voucher.eventType}`));
    row1.push(voucher.series ?? '');
    row1.push(voucher.company ?? '');
    row1.push(voucher.voucherText ?? '');
    // initialze second row with an empty space
    row2.push('');
    row2.push('');
    row2.push('');
    row2.push('');
    // each row has a static transaction part which is never empty
    row1.push(t('position.Debit'));
    row2.push(t('position.Credit'));
    row1.push(voucher.debit.accountNumber);
    row2.push(voucher.credit.accountNumber);
    row1.push(
      ...extractAccountingObjectValues(voucher.debit.accountingObjects)
    );
    row2.push(
      ...extractAccountingObjectValues(voucher.credit.accountingObjects)
    );
    // insert transaction text into row
    row1.push(voucher.transactionText ?? '');
    row2.push(voucher.transactionText ?? '');
    rows.push(row1);
    rows.push(row2);
  });
  return rows;
};

export { extractHeader, extractRows };
